module.exports = __webpack_public_path__ + "static/media/fly0252.943a69c0.webp";